import { render, staticRenderFns } from "./EditorNewAssignmentItem.vue?vue&type=template&id=6608646d&scoped=true&"
import script from "./EditorNewAssignmentItem.vue?vue&type=script&lang=js&"
export * from "./EditorNewAssignmentItem.vue?vue&type=script&lang=js&"
import style0 from "./EditorNewAssignmentItem.vue?vue&type=style&index=0&id=6608646d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6608646d",
  null
  
)

export default component.exports